import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "resultProductConsiderationCheckbox",
    "resultRiskAssociatedCheckbox",
    "resultOfSuitabilityTestCheck",
    "resultOfSuitabilityTestRiskToleranceCheck",
    "digitalDeliveryCheckbox",
    "personalDeliveryCheckbox"
  ]

  connect() {
    this.resultProductConsiderationCheckboxTarget.addEventListener('change', this.handleResultProductConsiderationChange.bind(this))
    this.resultRiskAssociatedCheckboxTarget.addEventListener('change', this.handleResultRiskAssociatedChange.bind(this))
    this.resultOfSuitabilityTestCheckTarget.addEventListener('change', this.handleResultOfSuitabilityTestCheckChange.bind(this))
    this.resultOfSuitabilityTestRiskToleranceCheckTarget.addEventListener('change', this.handleResultOfSuitabilityTestRiskToleranceCheckChange.bind(this))
    this.digitalDeliveryCheckboxTarget.addEventListener('change', this.handleDigitalDeliveryChange.bind(this))
    this.personalDeliveryCheckboxTarget.addEventListener('change', this.handlePersonalDeliveryChange.bind(this))

    this.handleResultProductConsiderationChange({ target: this.resultProductConsiderationCheckboxTarget })
    this.handleResultRiskAssociatedChange({ target: this.resultRiskAssociatedCheckboxTarget })
    this.handleResultOfSuitabilityTestCheckChange({ target: this.resultOfSuitabilityTestCheckTarget })
    this.handleResultOfSuitabilityTestRiskToleranceCheckChange({ target: this.resultOfSuitabilityTestRiskToleranceCheckTarget })
    this.handleDigitalDeliveryChange({ target: this.digitalDeliveryCheckboxTarget })
    this.handlePersonalDeliveryChange({ target: this.personalDeliveryCheckboxTarget })
  }

  disconnect() {
    this.resultProductConsiderationCheckboxTarget.removeEventListener('change', this.handleResultProductConsiderationChange.bind(this))
    this.resultRiskAssociatedCheckboxTarget.removeEventListener('change', this.handleResultRiskAssociatedChange.bind(this))
    this.resultOfSuitabilityTestCheckTarget.removeEventListener('change', this.handleResultOfSuitabilityTestCheckChange.bind(this))
    this.resultOfSuitabilityTestRiskToleranceCheckTarget.removeEventListener('change', this.handleResultOfSuitabilityTestRiskToleranceCheckChange.bind(this))
    this.digitalDeliveryCheckboxTarget.removeEventListener('change', this.handleDigitalDeliveryChange.bind(this))
    this.personalDeliveryCheckboxTarget.removeEventListener('change', this.handlePersonalDeliveryChange.bind(this))
  }

  handleResultProductConsiderationChange(event) {
    const isChecked = event.target.checked
    if (isChecked) {
      this.resultRiskAssociatedCheckboxTarget.checked = false
    }
  }

  handleResultRiskAssociatedChange(event) {
    const isChecked = event.target.checked
    if (isChecked) {
      this.resultProductConsiderationCheckboxTarget.checked = false
    }
  }

  handleResultOfSuitabilityTestCheckChange(event) {
    const isChecked = event.target.checked
    if (isChecked) {
      this.resultOfSuitabilityTestRiskToleranceCheckTarget.checked = false
    }
  }

  handleResultOfSuitabilityTestRiskToleranceCheckChange(event) {
    const isChecked = event.target.checked
    if (isChecked) {
      this.resultOfSuitabilityTestCheckTarget.checked = false
    }
  }

  handleDigitalDeliveryChange(event) {
    const isChecked = event.target.checked
    if (isChecked) {
      this.personalDeliveryCheckboxTarget.checked = false
    }
  }

  handlePersonalDeliveryChange(event) {
    const isChecked = event.target.checked
    if (isChecked) {
      this.digitalDeliveryCheckboxTarget.checked = false
    }
  }
}
